<template>
  <div class="about">
    <img :src="bannerImg" class="bannerImg">
    <an-child>
      <div slot="c_left" class="left_nav">
        <h3 class="title-color">
          <a>{{$store.state.langData.artical}}</a>
        </h3>
        <ul>
          <li v-for="(item,index) in cleft" :key="index">
            <router-link :to="'/article?type='+item.type" exact>{{item.name}}</router-link>
          </li>
        </ul>
      </div>
      <div slot="c_right">
        <div class="bread d-flex">
          <h3 class="flex-auto">
            <a class="text-blue">{{title}}</a>
          </h3>
          <div class="text-gray_dark d-flex">
            <span>
              <img src="@/assets/images/p.png" class="pic">
            </span>
            {{$store.state.langData.nowAddress}}：
            <router-link :to="'/article?type='+type">{{$store.state.langData.artical}}</router-link>>
            <a>{{title}}</a>
          </div>
        </div>
        <div v-if="type != 3 && type != 4" v-html="aboucompany.content"></div>
        <div v-if="type == 3 || type == 4">
          <div v-for="(recList,e) in recList" :key="e">
            <div class="companyName">{{recList.name}}<span>招聘岗位：</span></div>
            <table border="1">
              <thead>
                <tr>
                  <th>招聘部门</th>
                  <th>岗位名称</th>
                  <th>发布时间</th>
                  <th>查看详情</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(posiList,i) in recList.posiList" :key="i">
                  <td>{{posiList.department}}</td>
                  <td>{{posiList.post}}</td>
                  <td>{{posiList.releaseTime}}</td>
                  <td>
                    <router-link
                      target="_blank"
                      :to="'/about/introduction?id='+ posiList.id +'&title='+title"
                    >查看详情</router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </an-child>
  </div>
</template>

<script>
import { getBanner } from "@/api";
import {
  getAboutList,
  getArticalClassify,
  getAbout,
  getRecruiList,
  getArticalInfo
} from "@/api/hjy";
export default {
  name: "article",
  data() {
    return {
      cleft: [],
      bannerImg: "", //banner
      aboucompany: {},
      bannerShow: false,
      type: "",
      recList: [],
      totalPages: 0, //总页数
      currentPage: 1, //当前页数
      startPage: 1, //开始页
      endPage: 1, //结束页
      xyType: ""
    };
  },

  //请求方法
  methods: {
    //获取分类
    getAboutList() {
      getArticalClassify()
        .then(res => this.cleft.push(...res.data), console.log(this.cleft))
        .catch(e => console.log(e));
    },

    // 获取banner
    getBannerImg() {
      getBanner({ params: "2", ad_type: "10" }).then(res => {
        this.bannerImg = res.list[0].imageUrl;
      });
      this.bannerShow = true;
    },
    // 获取富文本
    getAboutText() {
      getArticalInfo({ type: this.$route.query.type }).then(res => {
        this.type = this.$route.query.type;
        this.aboucompany = res.data;
      });
    },
    // 获取社会或者校园招聘数据
    getRecruiList() {
      let dataType = "";
      if (this.xyType == 3) {
        dataType = 0;
      } else if (this.xyType == 4) {
        dataType = 1;
      }
      getRecruiList({
        type: dataType
      })
        .then(res => {
          console.log(res);
          this.recList = res.data;
          this.totalPages = res.data.totalPage;
          this.startPage = this.currentPage <= 2 ? 1 : this.currentPage - 2;
          if (this.startPage + 4 > this.totalPages) {
            this.endPage = this.totalPages;
            this.startPage = this.endPage - 4 < 1 ? 1 : this.endPage - 4;
          } else {
            this.endPage = this.startPage + 4;
          }
        })
        .catch(e => console.log(e));
    },
    handlePageClick(num) {
      this.currentPage = num;
      this.getRecruiList();
    },
    handleLastClick() {
      this.currentPage === 1 ? null : this.currentPage--;
      this.getRecruiList();
    },
    handleNextClick() {
      this.currentPage === this.totalPages ? null : this.currentPage++;
      this.getRecruiList();
    }
  },
  computed: {
    title() {
      let type = this.$route.query.type;
      let t = "";
      this.cleft.map(n => {
        if (n.type == type) {
          t = n.name;
          return;
        }
      });
      this.getAboutText();
      if (type == 3 || type == 4) {
        this.xyType = type;
        this.getRecruiList();
      }
      return t;
    },
    type() {
      return this.cleft.length > 0 ? this.cleft[0].type : "";
    }
  },
  mounted() {
    this.getAboutList();
    this.getBannerImg();
  }
};
</script>
<style lang="stylus">
.bannerImg {
  width: 1200px;
  height: auto;
  margin: 15px auto;
  display: block;
}

.about {
  padding-bottom: 88px;
}
.companyName{
  color:#1278C6;
  font-weight:bold;
  margin-bottom:16px;
  font-size:18px;
  span{
    font-weight:normal;
    margin-left:10px;
    font-size:16px;
  }
}
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border: solid #E4EAEC;
  border-width: 1px 0px 0px 1px;
  margin-bottom:40px;
  thead {
    th {
      background: #F3F3F4;
      font-size: 14px;
      width: 25%;
      color: #666;
      font-weight: normal;
      line-height: 48px;
    }
  }

  tbody {
    td {
      text-align: center;
      line-height: 60px;
      font-size: 14px;
    }

    td:nth-child(2) {
      color: #1278C6;
      font-weight: bold;
    }

    td:nth-child(4) {
      a {
        width: 94px;
        height: 32px;
        line-height: 32px;
        color: #ffffff;
        background: #1278C6;
        border-radius: 4px;
        display: block;
        margin: 0 auto;
      }
    }
  }
}
</style>

